import React from "react";
import "../css/work.css";
import photo1_1 from "../img/photo1_1.webp";
import photo1_2 from "../img/photo1_2.webp";
import photo1 from "../img/photo1.webp";
import photo2 from "../img/photo2.webp";
import photo3 from "../img/photo3.webp";
import photo4 from "../img/photo4.webp";
import photo4_1 from "../img/photo4_1.webp";
import photo5 from "../img/photo5.webp";
import photo6 from "../img/photo6.webp";
import photo7 from "../img/photo7.webp";
import linea from "../img/linea.webp";
import planet from "../img/planet.webp";
import { Helmet } from "react-helmet";

export default function Work() {
  return (
    <section className="work">
      <Helmet>
        <title>Yacht Repair Projects | Panama Marine Services</title>
        <meta
          name="description"
          content="Explore our international yacht repair projects in Panama, Alaska, the Caribbean and beyond. Trusted marine maintenance for support vessels and luxury yachts."
        />
        <link rel="canonical" href="https://panamarinerepair.com/ourWork" />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Panamarine Repair" />
      </Helmet>
      <h2>Our work</h2>
      <h1>We make your trip safe around the world</h1>
      <img
        className="planeta"
        src={planet}
        alt="Illustration of a globe representing global service coverage"
      />
      <div className="principal-work">
        <div className="section-left">
          <div>
            <img
              id="img-1"
              src={photo1_1}
              alt="Yacht maintenance in Panama 2023"
            />
            <div className="izq-1">
              <h3>Panama</h3>
            </div>
          </div>
          <div>
            <img
              src={photo1}
              alt="Fort Lauderdale International Boat Show 2022"
            />
            <div className="izq-2">
              <h3>Fort Lauderdale International Boat show</h3>
            </div>
          </div>
          <div>
            <img src={photo3} alt="Yacht in Alaskan waters 2022" />
            <div className="izq-3">
              <h3>Alaska</h3>
            </div>
          </div>
          <div>
            <img
              src={photo4_1}
              alt="Yacht repair in La Romana Dominican Republic"
            />
            <div className="izq-4">
              <h3>La Romana - Dom Rep</h3>
            </div>
          </div>
          <div>
            <img
              src={photo6}
              alt="Panama marine maintenance and yacht repair"
            />
            <div className="izq-5">
              <h3>Panama</h3>
            </div>
          </div>
        </div>
        <img
          className="img-line"
          src={linea}
          alt="Panama marine maintenance and yacht repair"
        />
        <div className="section-right">
          <div>
            <div id="top-right">
              <h3>Panama</h3>
            </div>
            <img
              className="dere1"
              src={photo1_2}
              alt="Logistics support vessel in Panama 2023"
            />
          </div>
          <div className="space-right">
            <div className="dere2">
              <h3>Alaska</h3>
            </div>
            <img src={photo2} alt="Crew operating in Alaskan waters 2023" />
          </div>
          <div>
            <div className="dere3">
              <h3>Cancún - Cozumel</h3>
            </div>
            <img
              src={photo4}
              alt="Marine operation in Cancún and Cozumel 2022"
            />
          </div>
          <div>
            <div className="dere4">
              <h3>Panama</h3>
            </div>
            <img
              src={photo5}
              alt="Maintenance services on a support boat in Panama 2022"
            />
          </div>
          <div>
            <div className="dere5">
              <h3>The island of antigua</h3>
            </div>
            <img
              src={photo7}
              alt="Yacht service on the island of Antigua 2019"
            />
          </div>
        </div>
      </div>
      <p style={{ position: "absolute", left: "-9999px" }}>
        Our Panama yacht repair services are trusted by clients worldwide for
        quality and speed.
      </p>
    </section>
  );
}
